/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_Bundle_UpdateInputs */

const en_mobile_ota_bundle_update = /** @type {(inputs: Mobile_Ota_Bundle_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OTA update`)
};

const es_mobile_ota_bundle_update = /** @type {(inputs: Mobile_Ota_Bundle_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización OTA`)
};

/**
* | output |
* | --- |
* | "OTA update" |
*
* @param {Mobile_Ota_Bundle_UpdateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_bundle_update = /** @type {((inputs?: Mobile_Ota_Bundle_UpdateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_Bundle_UpdateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_bundle_update(inputs)
	return en_mobile_ota_bundle_update(inputs)
});